/**
 * Plan-tier rules for the manuscript Feedback (Edit) product.
 * Hobby/Student, Limited Free, and unknown/unpaid users are excluded.
 */

/**
 * Returns true when the pricing plan title grants paid manuscript-feedback access.
 * @param {string | undefined | null} title
 * @returns {boolean}
 */
export function manuscriptFeedbackPaidPlanTitleAllowed(title) {
  if (!title || typeof title !== "string") return false;
  return title !== "Limited Free" && !/\b(Hobby|Student)\b/i.test(title);
}
